import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ElementModel } from 'projects/core/src/lib/models/element.model';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-element-list',
  templateUrl: './element-list.component.html',
  styleUrls: ['./element-list.component.scss']
})
export class ElementListComponent implements OnInit {

  @Input() exercise: ExerciseModel = null;
  @Input() inOrdering = false;
  @Output() exerciseChange = new EventEmitter<ExerciseModel>();
  @Output() rowReorder = new EventEmitter<any>();

  public inheritVisible = false;
  public inheritElement: any = null;
  public inheritMode: 'delete' | 'duplicate' = 'delete';

  constructor(
    private router: Router,
    private api: ApiService,
    private auth: AuthStateService,
    private confirmationService: ConfirmationService,
    private ui: UiService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  public onOpenElement(element: ElementModel): void {
    if (this.exercise !== null && this.auth.hasRight('admin.exercise.show')) {
      this.router.navigate(['/exercises', this.exercise.id, 'elements', element.id]);
    }
  }

  public onDuplicateElement(element: ElementModel): void {
    if (this.auth.hasRight('admin.element.create')) {
      this.confirmationService.confirm({
        message: this.transloco.translate('common.messages.really_duplicate', { value: element.name }),
        header: this.transloco.translate('common.really_duplicate'),
        icon: 'pi pi-question-circle',
        accept: () => {
          this.inheritElement = element;
          this.inheritMode = 'duplicate';
          if (this.exercise?.shouldShowInheritDialog()) {
            this.inheritVisible = true;
          } else {
            this.duplicateElement(false);
          }
        }
      });
    }
  }

  public onDeleteElement(element: ElementModel): void {
    if (this.auth.hasRight('admin.exercise.delete')) {
      this.confirmationService.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: element.name }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.inheritElement = element;
          this.inheritMode = 'delete';
          if (this.exercise?.shouldShowInheritDialog()) {
            this.inheritVisible = true;
          } else {
            this.deleteElement(false);
          }
        }
      });
    }
  }

  private duplicateElement(inherit: boolean = false): void {
    this.api.duplicateElement(this.inheritElement.id, inherit).subscribe({
      next: (result: any) => {
        this.ui.toastSuccess(this.transloco.translate('common.messages.duplicated', { value: this.inheritElement.name }), this.transloco.translate('common.duplicated'));
        this.exercise = new ExerciseModel().deserialize(result.data);
        this.exerciseChange.emit(this.exercise);
      },
      error: (error: any) => {
        this.ui.toastError(this.transloco.translate(error.message));
      }
    });
  }

  private deleteElement(inherit: boolean = false): void {
    this.api.deleteModel('elements', this.inheritElement.id, { inherit }).subscribe({
      next: (result: any) => {
        this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.inheritElement.name }), this.transloco.translate('common.deleted'));
        this.exercise = new ExerciseModel().deserialize(result.data);
        this.exerciseChange.emit(this.exercise);
      },
      error: (error: any) => {
        this.ui.toastError(this.transloco.translate(error.message));
      }
    });
  }

  public executeInheritAction(inherit: boolean): void {
    if (this.inheritMode === 'duplicate') {
      this.duplicateElement(inherit);
    } else {
      this.deleteElement(inherit);
    }
  }

  public onRowReorder(event: any): void {
    this.rowReorder.emit(event);
  }

}
